<template>
    <section id="ModalChangePhone">
        <fieldset>
            <div class="row col-md-12 mt-3">
                    <label>{{$t('Current Password ')}}</label>
            </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group form-group-feedback">
                            <input :type="showPasswordType" :placeholder="$t('Enter current password...')" class="form-control mb-1" v-model="currentPassword">
                                <span class="form-control-feedback" style="margin-left: 90%;">
                                    <a class="cursor-pointer" @click="showPassword"><i :class="iconShowPassword"></i></a>
                                </span>
                                <label
                                    class="validation-invalid-label"
                                    for="variationInfo_code"
                                    v-if="!validPassword"
                                    >{{ $t("Password is incorrect. Try again.") }}
                                </label>
                            <u @click="resetPassword" class="forgotPassword cursor-pointer">{{$t('Forgot password?')}}</u>
                        </div>
                    </div>
                </div>
            <div class="form-group">
                <label>{{$t('New Phone Number')}}</label>
                <input type="text" :placeholder="$t('Enter phone number...')" class="form-control" v-model="$parent.newPhone" maxlength="10">
                <label
                    class="validation-invalid-label"
                    for="variationInfo_code"
                    v-if="!validExistPhone"
                    >{{ $t("This phone number is already in use. Try again.") }}
                </label>
                <label
                    class="validation-invalid-label"
                    for="variationInfo_code"
                    v-if="!validEmptyPhone"
                    >{{ $t("Please enter phone number.") }}
                </label>
            </div>
            <!-- <div class="form-group">
                <i class="far fa-info-circle mr-2"></i>{{$t('Changing your phone number will also change your username')}}
            </div> -->
        </fieldset>
        <!-- <fieldset v-if="confirmOTP">
            <legend class="text-uppercase font-size-sm font-weight-bold">{{$t('Verification')}}</legend>
             <div class="form-group">
                {{$t('You will receive an SMS message +66 92 564 4441 with confirmation code.')}}
            </div>
            <div class="form-group">
                <input type="text" placeholder="Please enter the 6 digit verification code." class="form-control">
            </div>
            <div class="form-group">
                <div class="text-muted">{{$t("Didn't receive the verification OTP ?")}} <a href="#"><u>{{$t("Resend Again")}}</u></a></div>
            </div>
        </fieldset> -->
        <div class="form-group mt-3 mb-0">
            <div class="text-center">
                <!-- <button v-if="confirmOTP==false" type="submit" @click="sendOTP()" class="btn  btn-primary mr-2"><i class="fa-sms far mr-2 mr-2"></i>{{$t('Send OTP')}}</button> -->
                <!-- <button v-if="confirmOTP" type="submit" @click="isConfirmOTP()" class="btn  btn-primary mr-2"><i class="fas fa-save mr-2"></i>{{$t('Save')}}</button> -->
                <button @click="submitPhone" class="btn btn-primary mr-2 btn-ladda btn-ladda-spinner ladda-button" type="button" :class="[loading ? 'disabled' : '']">
                        <i :class="[loading ? 'icon-spinner2 spinner' : 'fa-solid fa-circle-check','mr-1',]"></i>
                        {{ $t("Confirm") }}
                </button>
                <!-- <button type="button" class="btn btn-primary mr-2" @click="submitPhone"><i class="fa-solid fa-circle-check mr-1"></i>{{$t('Confirm')}}</button> -->
                <button type="button" class="btn btn-light" data-dismiss="modal">{{$t('Cancel')}}</button>
            </div>
        </div>
    </section>
</template>
<script>

import CentralApi from '@/services/endpoint/central.service';
import bcrypt from "bcryptjs";


export default {
    data() {
        return {
            showPasswordType: 'password',
            iconShowPassword: 'far fa-eye-slash',
            confirmOTP: false,
            currentPassword: '',
            validPassword: true,
            validExistPhone: true,
            validEmptyPhone: true,
            loading: false,
            selectloading: false,
            menuVerificationCode: false,
            verifyOption:'',
            countdown: 0,
            displayCountdown: '',
            verificationCode: '',
            alreadyCode: false,
            loading: false
        }
    },
    mounted(){
        this.$root.$on("handleRegister", ()=> {
            // console.log('this. fn');
            this.handleRegister();
        }),
        this.$root.$on("sendSms", ()=> {
            this.sendSms();
        }),
        this.$root.$on("countDownTimer", ()=> {
            this.countDownTimer();
        })
        
    },
    methods: {
        resetPassword() {
            this.$parent.showModalForgotPassword = true;
        },
        showPassword() {
            this.showPasswordType = this.showPasswordType === 'password' ? 'text': 'password';
            this.iconShowPassword = this.iconShowPassword === 'far fa-eye-slash'? 'far fa-eye': 'far fa-eye-slash';
        },

        async submitPhone(){
            this.loading = true;
            this.message = ''
            if(this.$parent.newPhone != '' && this.$parent.newPhone != undefined){
                let prefixLength = 0;
                let suffixLength = 4;
                let prefix  = this.$parent.newPhone.substring(0, prefixLength);
                let suffix  = this.$parent.newPhone.slice(-suffixLength);
                let nbStars = this.$parent.newPhone.length - (prefixLength + suffixLength);
                this.$parent.showPhone = prefix + "*".repeat(nbStars) + suffix;

                const data = {mobile: this.$parent.newPhone, password: this.currentPassword};
                let res = await CentralApi.Auth.checkEmailAndPhone(data);
                this.validPassword = true;
                this.validExistPhone = true;
                this.validEmptyPhone = true;
                if(res.data.message != undefined){
                    if(res.data.code == 'Unauthenticated'){
                        this.validPassword = false;
                    }else{
                        if(res.data.message == 'Exist phone number'){
                            this.validExistPhone = false;
                        }
                    }
                    this.loading = false;
                }else{
                    await this.$nextTick(() => {
                        this.countdown = 600;
                    });
                    this.countDownTimer();
                    $('#ModalChangePhone').modal('hide');
                    $('#ModalVerifiPhone').modal('show');
                    this.$parent.inputVerficationCode = '';
                    
                    this.sendSms();
                    this.loading = false;

                }
                
            }else{
                this.loading = false;
                this.validEmptyPhone = false;
            }
        },

        countDownTimer () {
            if (this.countdown > 1) {
                setTimeout(() => {
                    this.countdown -= 1;

                    let minutes = Math.floor(this.countdown / 60);
                    let seconds = this.countdown % 60;
                    
                    minutes = this.padMinute(minutes);
                    seconds = this.pad(seconds);

                    this.displayCountdown = `${minutes}:${seconds}`;
                    this.countDownTimer()
                }, 1000)
            }
        },
        pad(n){
            return n > 9 ? "" + n : "0" + n;
        },
        padMinute(n){
            return this.countdown >= 600 && n <= 9 ? "0" + n : "" + n;
        },
    

        handleRegister() {
            if (this.countdown > 0) {
                let text_inputVerficationCode = this.$parent.inputVerficationCode;
                let text_inputVerficationCode_length =
                    text_inputVerficationCode;
                let first_inputVerficationCode =
                    text_inputVerficationCode.substr(0, 3);
                let end_inputVerficationCode = text_inputVerficationCode.substr(
                    3,
                    text_inputVerficationCode_length
                );
                let full_inputVerficationCode =
                    first_inputVerficationCode +
                    "GoSaaS" +
                    end_inputVerficationCode;
                

                bcrypt
                    .compare(full_inputVerficationCode, this.verificationCode)
                    .then((res) => {
                        if (res === true) {
                            CentralApi.Auth.updateEmailAndPhone({mobile: this.$parent.newPhone});
                            $('#mobile').val(this.$parent.newPhone);
                            $('#ModalVerifiPhone').modal('hide');
                            this.countdown = 1;
                            this.$toastr.s(
                            this.$t("Change Mobile Number Success"),
                            "<span class='t-icon icon-checkmark3'></span>" + this.$t("Success")
                            );
                            
                        } else {
                            this.message = "Input verification code not match, Try again!";
                        }
                    });
                } else {
                    this.message = "This verify code timed out!";
                }
        },
        
        async sendSms() {
            this.loading = true;
            this.selectloading = true;
            this.verifyOption = 'verify_sms';
            let params = {
                refroute: true,
                telephone: this.$parent.newPhone,
                message: this.$t(`We're happy you signed up for Goship. Please confirm your mobile no. with OTP = {OTP} This code expired in 10 minute`),
            };
            let data = await CentralApi.Auth.sendVerifySms(params);
            this.loading = false;
            this.selectloading = false;
            this.alreadyCode = true;
            this.verificationCode = data.data.randomNumber;
        
        },
        
    }
}
</script>

<style scoped>
    .forgotPassword{
        color: #2196f3 ;
    }

</style>


// WEBPACK FOOTER //
// src/components/central/account/profile/ModalChangePhone.vue